export default __webpack_public_path__ + "static/media/uploadButton.e4515742.svg";